var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMynauiLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5598 20.82C12.3963 20.9366 12.2006 20.9993 11.9998 20.9993C11.799 20.9993 11.6032 20.9366 11.4398 20.82C6.61078 17.378 1.48578 10.298 6.66678 5.182C8.08864 3.78212 10.0044 2.99826 11.9998 3C13.9998 3 15.9188 3.785 17.3328 5.181C22.5138 10.297 17.3888 17.376 12.5598 20.82Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 12.002C12.529 12.002 13.0377 11.7912 13.4127 11.4162C13.7878 11.0411 13.9985 10.5324 13.9985 10.002C13.9985 9.47152 13.7878 8.96281 13.4127 8.58774C13.0377 8.21267 12.529 8.00195 11.9985 8.00195C11.4681 8.00195 10.9594 8.21267 10.5843 8.58774C10.2092 8.96281 9.99854 9.47152 9.99854 10.002C9.99854 10.5324 10.2092 11.0411 10.5843 11.4162C10.9594 11.7912 11.4681 12.002 11.9985 12.002Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMynauiLocation);
export default __webpack_public_path__ + "static/media/mynaui_location.ca33f18d0a169cfbe7edaf36b01aa440.svg";
export { ForwardRef as ReactComponent };